import React, { useEffect } from "react";
import DataTable from "react-data-table-component";
import { useDispatch, useSelector } from "react-redux";
import KonkursImg from "../../assets/images/kon.jpg";
import "../../assets/scss/_profile.scss";
import { MContainer } from "../../element/Elemens";
import {
  fetchContestJoin,
  fetchContestParticipants
} from "../../redux/actions/userActions";

const Konkurs = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchContestParticipants());
  }, []);

  const columns = [
    {
      name: "#",
      cell: (row) => <div>{row.wrong_way}-o'rin</div>
    },
    {
      name: "Sotuvchilar",
      cell: (row) => <div>{row.last_name}</div>
    },
    {
      name: "Sotgan mahsuloti",
      cell: (row) => (
        <div style={{ fontWeight: "bold" }}>{row.contest_orders} ta</div>
      )
    }
  ];

  const userInfo = useSelector((state) => state.user.userInfo);
  const happeningList = useSelector((state) => state.user.list);

  return (
    <MContainer>
      <div className="competition__page">
        {/* <div>
          <img src={KonkursImg} className="competition__image__container" />
        </div> */}
        <div className="competition__page__body">
          <div className="competition__page__title">
            Uztez.uz jamaosi o’zining "Super konkursini" yana e’lon qiladi
          </div>
          <div className="competition__page__text">
            Uztez.uz jamoasi o'z xamkorlarini navbatdagi "Super konkursini" yana
            bir bor start beradi{" "}
            <span className="date_time_start">2025 yilning 20 aprel </span>{" "}
            sanasidan. Barcha xamkorlarimiz ushbu konkursda qatnashish
            imkoniyatiga ega. Konkursda qatnashish orqali o'z shaxsiy
            daromadlarini ko'paytirishi va qo'shimchasiga qimmatbaxo sovrinlarni
            qo'lga kiritishlari mumkin. Shartlari esa juda oddiy:  konkurs{" "}
            <span className="date_time_start"> 2025 yilning 20 aprel </span>{" "}
            sanasidan{" "}
            <span className="date_time_end"> 2025 yilning 5 may </span>{" "}
            sanasichagacha davom etadi va aynan shu vaqt oralig'ida siz 
            uztez.uz maxsulotlarini maksimal darajada ko'proq sotish orqali eng
            qimmatbaxo so'vrinlarni qo'lga kiritish imkoniyatiga ega bo'lasiz .
            <span className="date_time_hour">
              15 kun mobaynida ko’proq maxsulot soting va sovrinlarni qo’lga
              kiriting.
            </span>
          </div>
          <div className="competition__page__text">
            Aynan siz online savdo ishlarini uztez.uz sayti bilan xamkorlikda
            olib borasizmi? Unday bo’lsa ushbu konkurs aynan siz uchun. Konkurs
            orqali o’z shaxsiy daromadingizni ko’paytiring va qo’shimchasiga
            qimmatbaxo so’vrinlarni qo’lga kiriting.
          </div>
          <div className="competition__page__gift">
            <div className="competition__page__gift__title">
              So’vrinlarimiz:
            </div>
            <div className="competition__page__gift__d">
              1-o’ringa – NOUTBUK ACER ASPIRE LITE AMD R7-5700U 16GB 512GB 15,6
              FHD STEEL GRAY WINDOWS 11 -{" "}
              <span className="competition__page__gift__amount">4.000 ta</span>
            </div>
            <div className="competition__page__gift__d">
              2-o’ringa – Shivaki 6401-G gaz plitasi, elektr yoqish va gaz
              nazorati bilan -{" "}
              <span className="competition__page__gift__amount">3.000 ta</span>
            </div>
            <div className="competition__page__gift__d">
              3-o’ringa – Texnowell TWL-93 Mini-sovutgich, maksimal qulaylik -{" "}
              <span className="competition__page__gift__amount">2000 ta</span>
            </div>
            <div className="competition__page__gift__d">
              4-o’ringa – Televizor QLT 32", HD/Full HD SmartTV -{" "}
              <span className="competition__page__gift__amount">1000 ta</span>
            </div>
            <div className="competition__page__gift__d">
              5-o’ringa – Suv uchun kuler Sel E 3030, elektron sovutish tizimli
              - <span className="competition__page__gift__amount">900 ta</span>
            </div>
            <div className="competition__page__gift__d">
              6-o’ringa – Kalonka Karaoke simsiz 2 ta mikrafon, portativ
              Bluetooth , RGB yoritgich bilan -{" "}
              <span className="competition__page__gift__amount">700 ta</span>
            </div>
            <div className="competition__page__gift__d">
              7-o’ringa – Changyutgich Ideal VC-2010, 2200 Vt, Hepa filtr, 8 m -{" "}
              <span className="competition__page__gift__amount">600 ta</span>
            </div>
            <div className="competition__page__gift__d">
              8-o’ringa – Elektron duxovka va pichoq nabori -{" "}
              <span className="competition__page__gift__amount">500 ta</span>
            </div>
            <div className="competition__page__gift__d">
              9-o’ringa – Chinni Nabor 84 talik 12 kishi uchun -{" "}
              <span className="competition__page__gift__amount">400 ta</span>
            </div>
            <div className="competition__page__gift__d">
              10-o’ringa – Termopot Arshia, 9.8 litr, elektro choynak, suv
              isitgich, termos -{" "}
              <span className="competition__page__gift__amount">300 ta</span>
            </div>
            <div className="competition__page__gift__d">
              11-o’ringa – Qozonlar toʻplami 3 talik -{" "}
              <span className="competition__page__gift__amount">250 ta</span>
            </div>
            <div className="competition__page__gift__d">
              12-o’ringa – Chinni Nabor 32 talik 6 kishi uchun -{" "}
              <span className="competition__page__gift__amount">200 ta</span>
            </div>
            <div className="competition__page__gift__d">
              13-o’ringa – Chinni Choynak piyola nabor 6 kishi uchun -{" "}
              <span className="competition__page__gift__amount">130 ta</span>
            </div>
            <div className="competition__page__gift__d">
              14-o’ringa – Kiyimlar uchun yigʻma shkaf -{" "}
              <span className="competition__page__gift__amount">100 ta</span>
            </div>
            <div className="competition__page__gift__d">
              15-o’ringa – Fen-stayler, Dyson, 5 tasi 1, da barcha turdagi
              sochlar uchun -{" "}
              <span className="competition__page__gift__amount">90 ta</span>
            </div>
            <div className="competition__page__gift__d">
              16-o’ringa – Fen FaKang FK-9900, soch quritish uchun -{" "}
              <span className="competition__page__gift__amount">60 ta</span>
            </div>
            <div className="competition__page__gift__d">
              17-o’ringa – Pichoq nabor -{" "}
              <span className="competition__page__gift__amount">50 ta</span>
            </div>
            <div className="competition__page__gift__d">
              18-o’ringa – Massajiyor aparat -{" "}
              <span className="competition__page__gift__amount">40 ta</span>
            </div>
          </div>
          <div className="competition__page__footer">
            Konkurs 5 - may kunigacha davom etadi!
          </div>
          <div className="competition__page__footer">
            Konkurs tugaganidan so’ng sov’galar 15 kun ichida o’z egalariga
            topshiriladi!
          </div>
          {/* <div className="competition__page__footer">
            Xar bir sotilgan mahsulot konkursning dinariga qo'shilib boriladi.
            Konkurs davrida yig'ilgan dinarlar tugatilgandan so'ng ayirib
            yuboriladi
          </div> */}
        </div>
        {userInfo.attending_contest ? (
          ""
        ) : (
          <div
            className="competition__page__footer__button"
            onClick={() => {
              dispatch(fetchContestJoin());
            }}
          >
            Konkursga start berish
          </div>
        )}

        <div>
          <DataTable
            columns={columns}
            data={happeningList}
            responsive
            noHeader
            defaultSortAsc={false}
          />
        </div>
      </div>
    </MContainer>
  );
};

export default Konkurs;
